import {
    FETCH_TOP_RANKED_MEN,
    FETCH_TOP_RANKED_MEN_FAILURE,
    FETCH_TOP_RANKED_MEN_SUCCESS,
    FETCH_TOP_RANKED_WOMEN,
    FETCH_TOP_RANKED_WOMEN_FAILURE,
    FETCH_TOP_RANKED_WOMEN_SUCCESS,
    FETCH_TOP_RANKED,
    FETCH_TOP_RANKED_SUCCESS,
} from '../actions/top-ranked-actions';

const initialState = {
    men: {
        isLoading: false,
        error: null,
        players: [],
    },
    women: {
        isLoading: false,
        error: null,
        players: [],
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TOP_RANKED_MEN:
            return {
                ...state,
                men: {
                    ...state.men,
                    isLoading: true,
                },
            };
        case FETCH_TOP_RANKED_MEN_SUCCESS:
            return {
                ...state,
                men: {
                    error: null,
                    isLoading: false,
                    players: action.data,
                },
            };
        case FETCH_TOP_RANKED_MEN_FAILURE:
            return {
                ...state,
                men: {
                    error: action.data,
                    isLoading: false,
                    players: [],
                },
            };
        case FETCH_TOP_RANKED_WOMEN:
            return {
                ...state,
                women: {
                    ...state.women,
                    isLoading: true,
                },
            };
        case FETCH_TOP_RANKED_WOMEN_SUCCESS:
            return {
                ...state,
                women: {
                    error: null,
                    isLoading: false,
                    players: action.data,
                },
            };
        case FETCH_TOP_RANKED_WOMEN_FAILURE:
            return {
                ...state,
                women: {
                    error: action.data,
                    isLoading: false,
                    players: [],
                },
            };
        case FETCH_TOP_RANKED_SUCCESS:
            return {
                ...state,
                men: {
                    ...action.payload.men,
                    isLoading: false,
                },
                women: {
                    ...action.payload.women,
                    isLoading: false,
                },
            };
        case FETCH_TOP_RANKED:
            return {
                ...state,
                men: {
                    ...state.men,
                    isLoading: true,
                },
                women: {
                    ...state.women,
                    isLoading: true,
                },
            };
        default:
            return state;
    }
};
